import AliraOverview from '@/modules/integrations/types/alira/AliraOverview'
import AliraSettings from '@/modules/integrations/types/alira/AliraSettings'
import AliraPromotions from '@/modules/integrations/types/alira/AliraPromotions'

export default Object.freeze({
  type: 'alira',
  title: 'Integrations_Alira',
  category: 'Integrations_Alira_Category',
  description: 'Integrations_Alira_Description',
  image: require('@/img/integrations/tecnalis.svg'),
  requiresAdmin: false,
  components: {
    overview: AliraOverview,
    settings: AliraSettings,
    promotions: AliraPromotions
  },
  urls: {
    guide: 'https://docs.xtremepush.com/docs/alira'
  }
})



// WEBPACK FOOTER //
// ./src/modules/integrations/types/alira/index.js